export default {
  light: "#ffffff",
  black: "#222222",
  neutral: "#34313F",

  primary: "#611F96",
  secondary: "#C35BE3",

  error: "#FF5252",
  info: "#38afff",
  success: "#4CAF50",
  warning: "#ffc830",
};
